import {WidgetFullEditorPortal} from "../common/WidgetFullEditorPortal"
import {DiagramWidgetData} from "@dv5/domain"
import {FC} from "react"
import {useWidgetEditState} from "../../hooks/useWidgetEditState"
import {useWidgetEditor} from "../../hooks/useWidgetEditor"
import {EditorWidgetProps} from "../../model/WidgetProps"
import {widgetService} from "../../services/widgetService"
import {WidgetFrame} from "../common/WidgetFrame"
import {DiagramViewer} from "./DiagramViewer"
import {DiagramWidgetFullEditor} from "./DiagramWidgetFullEditor"
import {DiagramWidgetToolbar} from "./DiagramWidgetToolbar"
import './DiagramWidget.less'

type Props = EditorWidgetProps

export const DiagramWidget: FC<Props> = ({
                                             canvasId,
                                             widget,
                                             selected,
                                             settings,
                                             editingWidgetId,
                                             onStartDrag,
                                             onStartResize,
                                             onContextMenu,
                                             dragState,
                                             onStartLinkCreation,
                                             onCompleteLinkCreation,
                                             onNavigate,
                                             onDeleteDataLink,
                                             onStopEditing,
                                         }) => {
    const data = widget.data as DiagramWidgetData
    const {isFullEditor, setIsFullEditor, stopEditing} = useWidgetEditState(onStopEditing, settings.readOnly)

    const {
        containerRef,
        resizeCursor,
        handlers,
        renderResizeHandles,
        renderLinkDots,
    } = useWidgetEditor({
        widget,
        selected,
        editingWidgetId,
        dragState,
        onStartDrag,
        onStartResize,
        onContextMenu,
        onStartLinkCreation,
        onCompleteLinkCreation,
        onNavigate,
        onDeleteDataLink,
    })

    if (editingWidgetId && editingWidgetId === widget.id) {
        const toolbarStyles = widgetService.getToolbarStyle(widget)
        return (
            <div className='diagram-widget-edit-container' ref={containerRef} onContextMenu={handlers.onContextMenu}>
                {!isFullEditor && <DiagramWidgetToolbar
                    canvasId={canvasId}
                    widgetId={widget.id}
                    data={data}
                    toolbarStyles={toolbarStyles}
                    onExpandToFull={() => setIsFullEditor(true)}
                />}
                <div
                    className={widgetService.getWidgetClasses(widget, 'diagramWidget', selected, editingWidgetId, widget.commentsCount > 0)}
                    style={widgetService.getWidgetStyle(widget)}
                >
                    <DiagramViewer
                        sourceCode={data.text || ''}
                        diagramType={data.diagramType}
                        hideType={data.hideType}
                    />
                </div>
                {isFullEditor && (
                    <WidgetFullEditorPortal>
                        <DiagramWidgetFullEditor
                            canvasId={canvasId}
                            widgetId={widget.id}
                            data={data}
                            toolbarStyles={toolbarStyles}
                            onClose={stopEditing}
                        />
                    </WidgetFullEditorPortal>
                )}
            </div>
        )
    }

    return (
        <WidgetFrame
            baseClass='diagramWidget'
            canvasId={canvasId}
            widget={widget}
            settings={settings}
            selected={selected}
            editingWidgetId={editingWidgetId}
            resizeCursor={resizeCursor}
            handlers={handlers}
            containerRef={containerRef}
            renderResizeHandles={renderResizeHandles}
            renderLinkDots={renderLinkDots}
            onNavigate={onNavigate}
            onDeleteDataLink={onDeleteDataLink}
        >
            <DiagramViewer
                sourceCode={data.text || ''}
                diagramType={data.diagramType}
                hideType={data.hideType}
            />
        </WidgetFrame>
    )
}
